module.exports = __webpack_public_path__ + "img/icon-eye.716e65a3.svg";